import { authRoutes } from "../routes/allRoutes"

export const authUrls = authRoutes.map(a => a.path)
// auth URL 인지 체크
export const isAuthUrl = (url) => {
  return authUrls.includes(url)
}